import styles from "../../../../MapMonitoring/components/AddMarkerModal/AddIncidentModal.module.css";
import React, { useEffect, useMemo, useReducer } from "react";
import { TextField } from "@mui/material";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";
import { loadTypeService } from "../../../../../services/guide/loadType-service";
import { useFetchGetLoadTypeById } from "../../../../../hooks/guide/useFetchGetLoadTypeById";
import { CreateLoadType, UpdateLoadType } from "../../../../../types/api/guide/loadType.types";

type FormState = {
    name: string;
};

type Action =
    | { type: "SET_FIELD"; name: keyof FormState; value: any }
    | { type: "SET_All"; payload: FormState }
    | { type: "RESET" };

const initialState: FormState = {
    name: "",
};

const reducer = (state: FormState, action: Action): FormState => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.name]: action.value };
        case "SET_All":
            return { ...action.payload };
        case "RESET":
            return initialState;
        default:
            return state;
    }
};

interface LoadTypeAddModalProps {
    onClose: () => void;
    refetchData: () => void;
    id: string;
}

export const LoadTypeAddModal = ({ onClose, refetchData, id }: LoadTypeAddModalProps) => {
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();

    const { data: loadType } = useFetchGetLoadTypeById(id);

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!loadType) return;
        dispatch({
            type: "SET_All",
            payload: {
                name: loadType.name,
            },
        });
    }, [loadType]);

    const handleValue = (event: any) => {
        const { name, value } = event.target;
        dispatch({ type: "SET_FIELD", name, value });
    };

    const canSave = useMemo(() => {
        if (!state.name.trim()) return false;
        return true;
    }, [state]);

    const handleSave = async () => {
        try {
            if (!loadType) {
                const payload: CreateLoadType = {
                    name: state.name.trim(),
                };

                await loadTypeService.create(payload);
                showSuccess("Тип загрузки создан");
            } else {
                const payload: UpdateLoadType = {
                    id: loadType.id,
                    name: state.name.trim(),
                };

                await loadTypeService.update(loadType.id, payload);
                showSuccess("Тип загрузки обновлен");
            }

            refetchData();
        } catch (e: any) {
            showError(e?.response?.data ?? "Ошибка при обновлении/добавлении типа загрузки");
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        {loadType ? "Редактировать тип загрузки" : "Добавить тип загрузки"}
                    </h3>
                    <button className={styles.modalClose} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Название</div>
                        <div className={styles.modalCoords}>
                            <TextField name="name" value={state.name} onChange={handleValue} fullWidth />
                        </div>
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        Отмена
                    </button>

                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                        disabled={!canSave}
                        style={{ opacity: canSave ? 1 : 0.6 }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>

            <SnackbarComponent />
        </div>
    );
};
